import React from 'react';
import { useTranslation } from 'react-i18next';

const CheckupPage = ({ onButtonClick, onBack, onOpenMaleHealth, onOpenFemaleHealth, onOpenCardioPrevention, onOpenInfectionControl }) => {
  const { t } = useTranslation();
  
  const checkupServices = [
    { icon: 'male-health.png', name: t('checkupPage.services.maleHealth'), price: '' },
    { icon: 'female-health.png', name: t('checkupPage.services.femaleHealth'), price: '' },
    { icon: 'heart-check.png', name: t('checkupPage.services.cardioPrevention'), price: '' },
    { icon: 'infection-control.png', name: t('checkupPage.services.infectionControl'), price: '' },
    { icon: 'back.png', name: t('checkupPage.services.back'), price: '' }
  ];

  const handleServiceClick = (serviceName) => {
    if (serviceName === t('checkupPage.services.back')) {
      onBack();
    } else if (serviceName === t('checkupPage.services.maleHealth')) {
      onOpenMaleHealth();
    } else if (serviceName === t('checkupPage.services.femaleHealth')) {
      onOpenFemaleHealth();
    } else if (serviceName === t('checkupPage.services.cardioPrevention')) {
      onOpenCardioPrevention();
    } else if (serviceName === t('checkupPage.services.infectionControl')) {
      onOpenInfectionControl();
    } else {
      onButtonClick(serviceName);
    }
  };

  return (
    <>
      <header className="header">
        <div className="clinic-logo">
          <div className="logo-icon">
            <img src="/icons/checkup.png" alt={t('checkupPage.title')} width="40" height="40" />
          </div>
          <h1>{t('checkupPage.title')}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('checkupPage.subtitle')}</p>
        </div>
      </header>

      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('checkupPage.welcome')}</h2>
          <p className="subtitle">{t('checkupPage.chooseProgram')}</p>
        </div>

        <div className="buttons-grid">
          {checkupServices.map((service, index) => (
            <button 
              key={index}
              className={`service-btn ${service.name === t('checkupPage.services.back') ? 'back-btn' : ''}`}
              onClick={() => handleServiceClick(service.name)}
            >
              <span className="btn-icon">
                <img 
                  src={`/icons/${service.icon}`} 
                  alt={service.name} 
                  width="30" 
                  height="30" 
                />
              </span>
              <div className="service-info">
                <span className="service-name">{service.name}</span>
              </div>
            </button>
          ))}
        </div>
      </main>

      <footer className="footer">
        <p>{t('checkupPage.footer.main')}</p>
        <p className="footer-info">{t('checkupPage.footer.info')}</p>
      </footer>
    </>
  );
};

export default CheckupPage;